// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ru-z","tooltipWrapper":"Su-z","icon":"Tu-z","tooltip":"Uu-z","content":"Vu-z"};